import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Frame from "organisms/Frame"

const InlineWrapper = styled.div`
  width: 100%;
`

const FixedWrapper = styled.div`
  bottom: 100px;
  box-sizing: border-box;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 10000;
`

const WebPlayerWrapper = ({ iframe, type, children }) => {
  const Wrapper = type === "fixed" ? FixedWrapper : InlineWrapper

  if (iframe) {
    return (
      <Wrapper>
        <Frame type={type}>{children}</Frame>
      </Wrapper>
    )
  }
  return <Wrapper>{children}</Wrapper>
}

WebPlayerWrapper.propTypes = {
  iframe: PropTypes.bool,
  type: PropTypes.oneOf(["fixed", "inline"]),
  children: PropTypes.any,
}

WebPlayerWrapper.defaultProps = {
  type: "inline",
}

export default WebPlayerWrapper



// WEBPACK FOOTER //
// ./src/components/organisms/WebPlayerWrapper/index.js